import {
  Delete as DeleteIcon,
  OpenWith as OpenWithIcon,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  styled,
  TextField,
} from '@mui/material';

export const BackupComponentContainer = styled(Box)`
  width: 100%;
  margin-top: 10px;
`;

export const BackupComponentItem = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-right: 10px;
`;

export const InputTextField = styled(TextField)`
  width: 70px;
  .MuiInputBase-input {
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.23);
    border-radius: 4px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

export const BackupComponentName = styled(Box)(
  ({ theme }) => `
    color:${theme.palette.primary.main};
    overflow: hidden;
    padding: 4px 5px;
    flex: 1;
    min-width: 0;
    text-overflow: ellipsis;
    justify-content: flex-start;
  `,
);

export const BackupComponentButton = styled(Button)`
  width: 100%;
  text-align: left;
`;

export const DeleteIconStyled = styled(DeleteIcon)(
  ({ theme }) =>
    `
    width: 24px;
    height: 24px;
    path {
      fill: ${theme.palette.primary.main}
    }
  `,
);

export const OpenWithIconStyled = styled(OpenWithIcon)`
  width: 24px;
  height: 24px;
`;

export const StyledDivider = styled(Divider)`
  margin: 10px 0;
  margin-right: 10px;
`;

export const IconWrapper = styled(IconButton)`
  height: 40px;
  width: 40px;
  margin: 0 3px;
`;

export const DurationContainer = styled(Grid)`
  display: flex;
  width: 70px;
`;
